/* DSL Lazy reviews — fetch /products/{handle}.json metafields.reviews bij IO viewport-entry */
(function(){
  if (!("IntersectionObserver" in window)) return;
  var slot = document.querySelector("[data-lazy-reviews]");
  if (!slot) return;
  var handle = slot.dataset.productHandle;
  if (!handle) return;
  var io = new IntersectionObserver(function(entries){
    entries.forEach(function(e){
      if (!e.isIntersecting) return;
      io.unobserve(slot);
      slot.classList.add("dsl-skeleton", "dsl-skeleton--card");
      fetch("/products/" + handle + ".json").then(function(r){return r.json();}).then(function(p){
        slot.classList.remove("dsl-skeleton", "dsl-skeleton--card");
        var meta = (p.product && p.product.metafields) || {};
        if (window.DSL_AB) window.DSL_AB.track("lazy_reviews_load", {handle: handle});
      }).catch(function(){
        slot.classList.remove("dsl-skeleton", "dsl-skeleton--card");
      });
    });
  }, {rootMargin: "300px"});
  io.observe(slot);
})();